import React from "react";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import "./topRibbon.scss";
import { NEXCALIBER_DETAILS } from "../../../constants/companyDetails.constants";

const TopRibbon: React.FC = (): JSX.Element => {
	return (
		<div className="ribbon-main-container">
			<div className="left-section"></div>
			<div className="right-section">
				<div className="contact-links">
					<MdEmail color="white" />
					<span>{NEXCALIBER_DETAILS.NEXCALIBER_MAIL}</span>
				</div>
				<div className="contact-links">
					<FaPhoneAlt color="white" />
					<span>{NEXCALIBER_DETAILS.NEXCALIBER_CONTACT}</span>
				</div>
			</div>
		</div>
	);
};

export default TopRibbon;
